import { Box, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { PdfReferencesList } from "./pdf-references-list"

export function PdfReferencesSection({ section }) {
    if (!section?.changed && !section?.leftItems?.length && !section?.rightItems?.length) return null

    return (
        <Box component="tbody" sx={{ pageBreakBefore: "always", breakBefore: "page" }}>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={sectionHeadingCellSx}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography sx={{ fontWeight: 700, fontSize: "11px", color: "#1f2937" }}>
                            {section.title}
                        </Typography>
                        <If value={section.changed}>
                            <Typography sx={{ fontWeight: 700, fontSize: "10px", color: "#2b95a2" }}>
                                Changes Highlighted
                            </Typography>
                        </If>
                    </Stack>
                </Box>
            </Box>
            <Box component="tr">
                <Box component="td" sx={getContentCellSx("left", true)}>
                    <PdfReferencesList items={section.leftItems} emptyLabel="No references in this version" />
                </Box>
                <Box component="td" sx={getContentCellSx("right", true)}>
                    <PdfReferencesList items={section.rightItems} emptyLabel="No references in this version" />
                </Box>
            </Box>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={{ p: 0, pb: "24px" }} />
            </Box>
        </Box>
    )
}

const sectionHeadingCellSx = {
    p: 0,
    pb: "12px",
    borderBottom: "1px solid #d7dce2",
}

function getContentCellSx(side, highlight) {
    return {
        p: 0,
        pt: "14px",
        verticalAlign: "top",
        ...(side === "left" ? { pr: "20px" } : { pl: "20px" }),
        ...(highlight && side === "right" ? { borderLeft: "1px solid #d7dce2" } : {}),
    }
}
